import { render } from "./SummaryModuleCard.vue?vue&type=template&id=88b4d360&scoped=true"
import script from "./SummaryModuleCard.vue?vue&type=script&lang=js"
export * from "./SummaryModuleCard.vue?vue&type=script&lang=js"

import "./SummaryModuleCard.vue?vue&type=style&index=0&id=88b4d360&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b4d360"]])

export default __exports__